import React, {useEffect, useState } from 'react';
import axios from 'axios';
import BCMSBranding, {BCMSBrandingImage, BCMSBrandingStyle, BCMSBrandingDisabledIf} from "./components/BCMSBranding/main.jsx";
import BCMSController, { BCMSGlobalContext, useBCMSController, useBCMSGlobalController } from "./components/BCMSController/main.jsx";
import BCMSRegistry, { BCMSActive, useBCMSRegistry } from "./components/BCMSRegistry/main.jsx";
import BCMSPage from "./components/BCMSPage/main.jsx";
import BCMSWidget from "./components/BCMSWidget/main.jsx";
import BCMSSelect from "./components/BCMSSelect/main.jsx"
import BCMSSelectItem from "./components/BCMSSelect/BCMSSelectItem.jsx";
import BCMSWebAgent from "./classes/BCMSWebAgent/";
import BCMSTemplate from "./classes/BCMSTemplate/";
import BCMSModeler from "./classes/BCMSModeler/";
import BCMSValidate from "./classes/BCMSValidate";
import BCMSDispatcher from "./classes/BCMSDispatcher";
import BCMSDispatchHandler from './classes/BCMSDispatcher/src/BCMSDispatchHandler';
import BCMSDisclaimer, {hasAgreed} from "./components/BCMSDisclaimer/";
import {Link, Route, Routes, Navigate, Outlet, HashRouter, NavLink, useRoute, useParams, useBCMSRouteData } from './components/BCMSNav/main.jsx';
import BCMSDate from "./classes/BCMSDate/";
import BCMSCurrency from "./classes/BCMSCurrency/";
import BCMSQuery from "./classes/BCMSQuery";
import BCMSAsset from "./classes/BCMSAsset";
import BCMSWorkflow, { useBCMSWorkflow } from "./components/BCMSWorkflow/main.jsx";
import BCMSRecord from "./classes/BCMSRecord";
import BCMSRecordProperty from "./classes/BCMSRecord/src/BCMSRecordProperty";
import BCMSDisabledPrompt from "./components/BCMSDisabledPrompt/main.jsx";
import BCMSWorkflowStep from './classes/BCMSWorkflowStep/index.js';
import BCMSTransistion from './components/BCMSTransistion/main.jsx';
import BCMSModal, { BCMSModalHeader, BCMSModalContent, BCMSModalFooter, BCMSModalButton, BCMSModalContainer, useBCMSModal, BCMSModalOpen, BCMSModalClose } from "./components/BCMSModal/main.jsx";
import BCMSDefaultModel from './classes/BCMSDefaultModel/index.js';
import BCMSStateManager, { useBCMSStateManager, useUIState, useStateWithContext } from './components/BCMSStateManager/main.jsx';
import BCMSStateManagerCRUD from './classes/BCMSStateManagerCRUD/index.js';
import BCMSContext, { useBCMSContext } from './components/BCMSContext/main.jsx';

/**
 *
 *  Main Component
 *
 */

export default function BCMS (props) {
  const settings = Object.assign({
    "NODE_ENV":"production",
    "REACT_APP_MODEL_URL":"/path/to/model",
  }, props.env ?? {});
  const customCSS = props.customCSS ?? undefined;
  const url = settings.NODE_ENV === "production"
    ? BCMSWebAgent.getModelURL()
    : settings.REACT_APP_MODEL_URL;
  const [getModel, setModel] = useState(null);
  const HEAD = document.querySelector("head");
  // Loads model for demo:
  useEffect(() => {
    (async () => {
      try {
        let model = await axios.get(url).then(res=>res.data);
        setModel({ ...model, "env" : settings.NODE_ENV });
      } catch (err) {
        setModel({"error":err});
      }
    })();
  }, []);
  
  const [getBrandedStyle, setBrandedStyle] = useState(null);
  
  // Loads templated stylesheet for demo:
  useEffect(() => {
    (async () => {
      try {
       
           let BrandingStyle = await axios.get('static/branding.css').then(res=>res.data);
       
        setBrandedStyle(BrandingStyle);
       
       
      } catch (err) {
        setBrandedStyle("");
       
      }
    })();
  }, []);
  if (getModel === null) {
    // Show some loading message:
    return (<h3 style={{ padding: "20px" }}>Loading Model...</h3>);
  }
 
  if (getBrandedStyle === null) {
    // Show some loading message:
    return (<h3 style={{ padding: "20px" }}>Loading Branding...</h3>);
  }else{
    //applys branding to the templated stylesheet then appends to head
    let template = BCMSTemplate.init(getModel.branding.colors);
    let css = template.applyTo(getBrandedStyle);
    let style = document.createElement("style");
      style.innerHTML = css;
      HEAD.appendChild(style);
   
  }
  // Shows error message if error message has been set in model:
  if (getModel.error !== undefined) {
    console.log(getModel.error);
    return (<h1 style={{ padding: "20px" }}>Could Not Load Click-Thru</h1>);
  }

  // Checks to see if disclaimer is active:
  if (getModel.settings.hasDisclaimer === "true" && !hasAgreed()) {
    return (<BCMSDisclaimer></BCMSDisclaimer>);
  } else {
    // Apply branding to CSS:
    let template = BCMSTemplate.init(getModel.branding.colors);
    Array.from(document.querySelectorAll("style")).forEach(style=>{
     let css = template.applyTo(style.innerHTML);
     style.innerHTML = css;    
    });
    //  Add custom CSS styles:
    if (customCSS !== undefined) {
      let style = document.createElement("style");
      style.innerHTML = getModel.branding.options[customCSS];
      HEAD.appendChild(style);
    }
  }  

  // Start V2.7.2 Backward Compatibility
    // Initalize dispatcher and add default handlers
    const dispatchers = BCMSDispatcher.init()
    .add("updateModel", (state, action) => ({ ...state, ...action.payload }))
    .compose(props.dispatcher ?? BCMSDispatcher.init());

    document.addEventListener("check-branding", evt => {
      const { check, message, isTrue, isFalse } = evt.detail;
      const { branding } = getModel;

      if(check(branding)) { isTrue(); }
      else if(isFalse instanceof Function) { isFalse(); }
      else {
        document.write(`
          <div style="height: 100%; display: flex; align-items: center;justify-content: center;">
              <h1 style = "font-size:35px; text-align:center; vertical-align: middle;">
                  ${ message ?? "This capture does not show with the current branding" }
              </h1>
          </div>`);
      }
    });
  // End V2.7.2 Backward Compatibility

  // Initailzes global controller bound to loaded model and initalizes all routes of the demo:
  return (
    // Start V2.7.2 Backward Compatibility
    <BCMSController initState={getModel} dispatcher={ dispatchers }>
      <BCMSGlobalContext>
    { /** End V2.7.2 Backward Compatibility */ }
        <BCMSContext state={ getModel }>
          <HashRouter>
            <Routes>
              { props.defaultRoute && <Route path="/" element={ <Navigate to={ props.defaultRoute } /> } /> }

              { props.children }

              <Route
                path="*"
                element={
                  <main style={{ padding: "1rem" }}>
                    <p>No Route Found</p>
                  </main>
                }
              />
            </Routes>
          </HashRouter>
        </BCMSContext>
    { /** Start V2.7.2 Backward Compatibility */ }
      </BCMSGlobalContext>
    </BCMSController>
    // End V2.7.2 Backward Compatibility
  );
}

/**
 *
 *  Other Components
 *
 */

 // Defines BRANDING element for deciding if content should be show for a matched "value" in branding:
 export function Branding(props) {
   let {type, id, value, exp} = props;
   let {branding} = useModel();
   switch (type) {
     case "color":
       return <BCMSBranding model={branding.colors} id={id} value={value} exp={exp}>{props.children}</BCMSBranding>
     case "option":
     default:
       return <BCMSBranding model={branding.options} id={id} value={value} exp={exp}>{props.children}</BCMSBranding>
   }
 }

// NOTE: Branding data is explicity bound to initial state to support any nested Branding compnents:
export function Controller(props) {
  let model = useModel();
  let state = {branding:model.branding, ...props.initState, model:model}
  return <BCMSController initState={state} dispatcher={props.dispatcher}>
    {props.children}
  </BCMSController>
}

// formatDate :: (OBJECT)- > TEXTNODE
// NOTE: Takes a value and an optional config properties
// outputs the value in configured date format:
export function FormatDate(props) {
  return BCMSDate.init()
      .offset(props.offset ?? 0)
      .format(props.format ?? "m-d-Y")    
}

// React component for showing formatted currency:
export function FormatCurrency(props) {
    const {amount, options} = props;
       return BCMSCurrency.init(amount).format(options);
}

// React component for showing standard USD currency format:
export function Currency(props) {
  const {amount} = props;
     return BCMSCurrency.toCurrency(amount);
}

// OBJECT -> (EVENT) -> *
export function onClick(props) {
  return (evt) => {
    if(props.onClick instanceof Function) {
      props.onClick(evt);
    }
    else{
      throw new Error(`onClick props must be a FUNCTION, instead recieved "${props.onClick}"`);
    }
  };
}

/**
 *
 *  Custom Hooks
 *
 */

// Start V2.7.2 Backward Compatibility
  // For access to a copy of the MODEL stored by the demo:
  // NOTE: How we copy object an object here probably isn't the most ideal...
  export const useModel = () => {
    const { state } = useBCMSGlobalController();
    return JSON.parse(JSON.stringify(state));
  }

  // For access to state managed by BCMSGLOBALCONTEXT
  export const useGlobalController = () => useBCMSGlobalController();

  // For access to state managed by BCMSCONTROLLER element:
  // NOTE: This will probably be deprecated at some point:
  export const useController = () => useBCMSController();
// End V2.7.2 Backward Compatibility

// For access to registy that manages what components are "active":
export const useRegistry = () => useBCMSRegistry();

// For access to controllers in a workflow:
export const useWorkflow = () => useBCMSWorkflow();

// Start V2.7.2 Backward Compatibility
  // Return all hooks that are used in a workflow step
  export const useWorkflowStep = (defaultStepState, getSteps) => {
    const controller = useBCMSGlobalController();
    const workflow = useBCMSWorkflow();
    const navigate = useRoute();

    const steps = getSteps instanceof Function ? getSteps() : getSteps;
    const defaultValue = defaultStepState instanceof Function ? defaultStepState(controller) : defaultStepState;

    const [ stepState, setStepState ] = useState(workflow === undefined || workflow === null ? defaultValue : workflow.state);
    
    if(workflow) {
      useEffect(() => setStepState(workflow.state), [ workflow ]);
    }

    return new BCMSWorkflowStep(defaultValue, steps, controller, workflow, navigate, stepState, setStepState);
  };
// End V2.7.2 Backward Compatibility

/**
 *
 *  Other Exports
 *
 */

export {
  Link,
  Route,
  NavLink,
  Outlet,
  useRoute,
  useParams,
  BCMSModeler,
  BCMSValidate,
  BCMSActive as Active,
  BCMSRegistry as Registry,
  BCMSPage as Page,
  BCMSWidget as Widget,
  BCMSSelect as SelectUI,
  BCMSSelectItem as Item,
  BCMSWebAgent,
  BCMSDispatcher,  
  BCMSDate,  
  BCMSQuery,
  BCMSCurrency,
  BCMSDefaultModel,
  BCMSBrandingImage as BrandingImage,
  BCMSBrandingStyle as BrandingStyle,
  BCMSBrandingDisabledIf as BrandingDisabledIf,
  BCMSDispatchHandler,
  BCMSAsset,
  BCMSWorkflow as Workflow,
  BCMSRecord,
  BCMSRecordProperty,
  BCMSDisabledPrompt as DisabledPrompt,
  BCMSTransistion as Transistion,

  BCMSModal as Modal,
  BCMSModalHeader as ModalHeader,
  BCMSModalContent as ModalContent,
  BCMSModalFooter as ModalFooter,
  BCMSModalButton as ModalButton,
  BCMSModalContainer as ModalContainer,
  BCMSModalOpen as ModalOpen,
  BCMSModalClose as ModalClose,

  useBCMSModal,
  useBCMSRouteData as useRouteData,

  BCMSStateManager as StateManager,
  useBCMSStateManager as useStateManager,

  useUIState,
  BCMSStateManagerCRUD,
  useStateWithContext,
  useBCMSContext
};
